import merge from 'lodash/merge';
export function initiateIntegrals(options) {
    return merge({
        values: [],
        options: {
            sum: undefined,
            isSumConstant: true,
            sumAuto: true,
        },
    }, options.integrals);
}
